module.exports = __webpack_public_path__ + "static/media/york-13.068087aa.jpg";